module.exports = __webpack_public_path__ + "resources/icon_28_invite.0be4323e8fddd9f7.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_invite.png
// module id = 469
// module chunks = 0 1 2 3 4